import { render, staticRenderFns } from "./MainPanel.vue?vue&type=template&id=786d24a6&scoped=true"
import script from "./MainPanel.vue?vue&type=script&lang=js"
export * from "./MainPanel.vue?vue&type=script&lang=js"
import style0 from "./MainPanel.vue?vue&type=style&index=0&id=786d24a6&prod&lang=scss"
import style1 from "./MainPanel.vue?vue&type=style&index=1&id=786d24a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786d24a6",
  null
  
)

export default component.exports